import { Button, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FallbackProps } from "react-error-boundary";

import { useQueryErrorResetBoundary } from "react-query";

interface Props extends FallbackProps {}

export function LayersFallback(props: Props) {
  const { resetErrorBoundary } = props;
  const { reset } = useQueryErrorResetBoundary();

  const { t } = useTranslation();

  function tryAgain() {
    reset();
    resetErrorBoundary();
  }

  return (
    <Styles>
      <Typography variant="subtitle2" color="error">
        {t("label.unableToLoadLayers")}
      </Typography>
      <Button className="align-bottom" onClick={tryAgain}>
        {t("label.tryAgain")}
      </Button>
    </Styles>
  );
}

const Styles = styled("div")`
  padding: ${({ theme }) => theme.spacing(2, 0)};
  display: flex;
  flex-direction: column;

  & > * + * {
    margin: ${({ theme }) => theme.spacing(2, 0)};
  }
`;
